import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgTrustly = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 36 28"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12.158 9.188h4.08V5.907l3.258 3.281-3.259 3.259v1.663h3.969V9.188h3.636V5.33H12.158zM7.915 21.468v-4.415H6.328v-1.062h4.305v1.049H9.046v4.414H7.915z"
      />
      <path
        fill="currentColor"
        d="M10.453 21.468v-3.973h1.049v.634c.248-.538.565-.634.91-.634h.4v1.062h-.345c-.497 0-.938.29-.938 1.159v1.752zM13.309 20.006v-2.511h1.09v2.276c0 .47.22.814.69.814.441 0 .731-.345.731-.8v-2.29h1.09v3.973h-1.035v-.497c-.262.4-.648.594-1.145.594-.883-.014-1.421-.607-1.421-1.56M17.351 20.35l.938-.22c.042.303.29.538.76.538.358 0 .565-.152.565-.331 0-.152-.083-.262-.456-.345l-.62-.138c-.787-.18-1.132-.538-1.132-1.214s.566-1.228 1.614-1.228c1.118 0 1.573.676 1.615 1.117l-.952.207c-.042-.234-.221-.483-.69-.483-.304 0-.524.139-.524.332 0 .165.11.262.303.303l.91.207c.69.152 1.008.566 1.008 1.159 0 .635-.497 1.283-1.642 1.283-1.241 0-1.642-.759-1.697-1.186M22.8 21.468c-.703 0-1.172-.386-1.172-1.159v-1.862h-.662v-.952h.662v-.883l1.09-.317v1.2h.8v.952h-.8v1.655c0 .29.152.4.442.4h.413v.952h-.772zM24.153 21.468v-5.477h1.09v5.477zM28.513 17.495h1.158l-1.655 5.394h-1.16l.456-1.42h-.593l-1.09-3.974h1.159l.814 3.076z"
      />
    </svg>
  );
};
export default SvgTrustly;
